import { TranslationKey } from '../translation/TranslationKey';
import { translate } from '../translation/Translator';
import { CompanyRole } from './companyRoleAssignment';

export namespace CompanyRoleAssignmentUtil {
  export function roleToString(role?: CompanyRole): string {
    if (!role) return '';

    switch (role) {
      case CompanyRole.administrator:
        return translate({ key: TranslationKey.administrator });
      case CompanyRole.employee:
        return translate({ key: TranslationKey.employee });
    }
  }
}
